import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=8eed0f8a&scoped=true"
import script from "./dashboards.vue?vue&type=script&lang=js"
export * from "./dashboards.vue?vue&type=script&lang=js"
import style0 from "./dashboards.vue?vue&type=style&index=0&id=8eed0f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eed0f8a",
  null
  
)

export default component.exports